import moment from 'moment';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { Text } from '../../../../components/Basic/WrapsStyle';
import { getDate, numberWithSpaces } from '../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';


const SupplyItemLine = ({
  product,
  getByDateStat = (_) => _,
  ...props
}) => {


  return (
    <TableLine >
      <TableCell width={WIDTH_POSTING[5]} center>
        <Text>{product._id ? getDate(product._id) : '-'}</Text>
      </TableCell>
      <TableCell width={WIDTH_POSTING[5]} center>
        <b>{product.total.total.count}</b>
      </TableCell>
      <TableCell width={WIDTH_POSTING[5]} center>
        <b>{product.total.sold.count}</b>
      </TableCell>
      <TableCell width={WIDTH_POSTING[5]} center>
        <b>{product.total.cancel.count}</b>
      </TableCell>
      <TableCell width={WIDTH_POSTING[5]} center>
        <b style={{ color: product.total.total.profit > 0 ? '#01800eca' : '#6e0000d9' }}> {numberWithSpaces(product.total.total.profit)} руб.</b>
      </TableCell>
    </TableLine >
  );
};

export default SupplyItemLine;
